import styles from './styles.module.scss';

export type LoadingSpinnerProps = {
  isAudio?: boolean;
};

const LoadingSpinner = ({ isAudio = false }: LoadingSpinnerProps) => {
  const playerType = isAudio ? 'Audio Player' : 'Video Player';

  return <div aria-label={`${playerType} is loading`} className={styles.loadingSpinner} />;
};

export default LoadingSpinner;
